import { useState, useMemo, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "api/api";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

// import mui icons

// import mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";

//import component
import Loader from "../components/common/Loader";
import Header from "../components/common/Header";
import UserRoleUpdateComponent from "../components/UserAccessManagement/UserRoleUpdateComponent";
import FullScreenConatiner from "components/layouts/FullScreenConatiner";

//redux
import { useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

//Ag Grid
import { AgGridReact } from "ag-grid-react";

const IOSSwitch = styled((props) => (
    <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#005EEF",
                opacity: 1,
                border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "#33cf4d",
            border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === "light" ? "grey" : "#005EEF",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
    },
}));
function UserAccessManagement({ headerTitle = "" }) {
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRowToUpdate, setSelectedRowToUpdate] = useState([]);
    const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
    const [rolesData, setRolesData] = useState([]);

    const multipleCellRender = (params) => {
        if (Array.isArray(params.value) && params.value.length > 0) {
            return (
                <div className="ag-multi-line-cell-render">
                    {params.value.map((datum) => {
                        const uniqueKey = `${datum.product_category__title} / ${datum.business_group__title} -${datum.role__title}`;

                        return (
                            <p
                                key={uniqueKey}
                                style={{
                                    paddingTop: 5,
                                }}
                            >
                                {`${datum.product_category__title} / ${datum.business_group__title} : ${datum.role__title}`}
                            </p>
                        );
                    })}
                </div>
            );
        } else {
            return;
        }
    };
    const nameCellRender = (params) => {
        let namePart = params.data.email.split("@");
        let finalName = titleCase(namePart[0].replaceAll(".", " "));
        return <div>{finalName}</div>;
    };

    const userAdminCellRender = ({ data }) => {
        return (
            <div>
                <span className={data.user_admin === false ? "color-blue text-bold-6" : ""}>False</span>
                <IOSSwitch
                    sx={{ m: 1 }}
                    checked={data.user_admin === true}
                    onChange={handleRoleChange(data.id)}
                />
                <span className={data.user_admin === true ? "color-blue text-bold-6" : ""}>True</span>
            </div>
        );
    };

    const actionCellRender = (row) => (
        <EditIcon
            color="primary"
            style={{
                cursor: "pointer",
            }}
            onClick={() => handleUpdateClick(row)}
        />
    );

    const columnDefs = [
        {
            headerName: "Name",
            field: "email",
            cellRenderer: nameCellRender,
        },
        {
            headerName: "Email ID",
            field: "email",
        },
        {
            headerName: "Category - Role",
            field: "user_product_categroy_role",
            cellRenderer: multipleCellRender,
            autoHeight: true,
        },
        {
            headerName: "User Admin",
            field: "user_admin",
            cellRenderer: userAdminCellRender,
        },
        {
            headerName: "Action",
            minWidth: 120,
            filter: false,
            cellRenderer: actionCellRender,
        },
    ];

    const fetchUserData = useCallback(() => {
        setIsLoading(true);
        const url = process.env.REACT_APP_SERVER_PATH + `/profiles/user-admin-access-management/?archive=false&ordering=-id`;
        api.get(url)
            .then(async (res) => {
                setUsers(res.data);
                setIsLoading(false);
            })
            .catch(async (error) => {
                handleError("error", error);
                setIsLoading(false);
            });
    }, []);

    const fetchRoles = useCallback(() => {
        const url = process.env.REACT_APP_SERVER_PATH + `/roles/all/`;
        api.get(url)
            .then(async (res) => {
                setRolesData(res.data);
            })
            .catch(async (error) => {
                handleError("error", error);
            });
    }, []);

    useEffect(() => {
        fetchUserData();
        fetchRoles();
    }, [fetchUserData, fetchRoles]);

    const handleUpdateClick = (row) => {
        setSelectedRowToUpdate(row.data);
        setIsUpdateDialogOpen(true);
    };

    function titleCase(str) {
        const splitStr = str.toLowerCase().split(" ");
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(" ");
    }

    const handleRoleChange = (userId) => (event) => {
        const url = process.env.REACT_APP_SERVER_PATH + `/profiles/${userId}/`;
        const formData = new FormData();
        formData.append("user_admin", event.target.checked);
        // Send an API request to update the user's role
        api.patch(url, formData)
            .then(() => {
                fetchUserData();
            })
            .catch((error) => {
                setIsLoading(false);
                handleError("error", error);
            });
    };

    const sortingOrder = useMemo(() => {
        return ["desc", "asc", null];
    }, []);

    const defaultColDef = useMemo(() => {
        return {
            editable: false,
            suppressMenu: true,
            sortable: true,
            filter: true,
            resizable: true,
            floatingFilter: true,
            filterParams: {
                filterOptions: ["contains"], // to get filter remove class .ag-floating-filter-button  form css
                // filterOptions: ["equals", "contains", "startsWith", "endsWith"], // to get filter remove class .ag-floating-filter-button  form css
            },
            cellStyle: { fontSize: "14px", border: "none" },
            minWidth: 490,
        };
    }, []);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    return (
        <>
            <div>
                {isLoading && <Loader />}
                <Header title={headerTitle} />
                <FullScreenConatiner
                    style={{
                        padding: "20px",
                        paddingTop: 0,
                        marginTop: 10,
                    }}
                    subHeight={90}
                >
                    <div
                        className=""
                        style={{
                            width: 150,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Link to="/">
                            <div
                                className="p-2 liner-light-blue-background color-white"
                                style={{
                                    borderRadius: "50%",
                                    position: "relative",
                                    top: -15,
                                    left: -35,
                                    cursor: "pointer",
                                }}
                            >
                                <span>
                                    <ArrowBackIcon className="color-white" />
                                </span>
                            </div>
                        </Link>
                    </div>
                    <div className="landing-page-table p-2 mb-0">
                        <div
                            className="ag-theme-alpine"
                            style={{ height: "calc(100vh - 180px)", width: "100%" }}
                        >
                            <AgGridReact
                                rowStyle={{
                                    background: "white",
                                }}
                                defaultColDef={defaultColDef}
                                rowData={users}
                                columnDefs={columnDefs}
                                onGridReady={(params) => params.id}
                                sideBar={true}
                                rowHeight={38}
                                headerHeight={40}
                                suppressDragLeaveHidesColumns={true}
                                sortingOrder={sortingOrder}
                            ></AgGridReact>
                        </div>
                    </div>
                </FullScreenConatiner>

                {isUpdateDialogOpen && (
                    <UserRoleUpdateComponent
                        title="Edit User Role"
                        type="update"
                        selectedRows={selectedRowToUpdate}
                        isOpen={setIsUpdateDialogOpen}
                        setIsUpdateDialogOpen={setIsUpdateDialogOpen}
                        rolesData={rolesData}
                        fetchData={fetchUserData}
                    />
                )}
            </div>
        </>
    );
}

// Typechecking props for the UserAccessManagement
UserAccessManagement.propTypes = {
    headerTitle: PropTypes.string,
};
export default UserAccessManagement;
